import {Button} from 'antd';
import React, {useEffect} from 'react';
import {BrowserRouter, Routes, Route} from "react-router-dom";
import './static/iconfont/iconfont.css'

const Pages = React.lazy(() => import('./page/index'));


function App() {
    useEffect(() => {
        document.title = " 立体联动孵化器信息化管理系统";
    });
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route>
                        <Route path="/swms/*" element={<Pages/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
